import { render, staticRenderFns } from "./add-prod.vue?vue&type=template&id=69127f08&scoped=true"
import script from "./add-prod.vue?vue&type=script&lang=js"
export * from "./add-prod.vue?vue&type=script&lang=js"
import style0 from "./add-prod.vue?vue&type=style&index=0&id=69127f08&prod&lang=scss&scoped=true"
import style1 from "./add-prod.vue?vue&type=style&index=1&id=69127f08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69127f08",
  null
  
)

export default component.exports